import { MoneyInOut } from '../AllAccountsCard/MoneyInOut'
import { TotalOverTimeChart } from '../AllAccountsCard/TotalOverTimeChart'
import type { PortfolioOverview } from '../model/portfolioOverview'
import { useLedgerGap } from '../usePortfolioOverview'
import { AccountFigure } from './AccountFigure'
import {
  accountHistory,
  accountNotCounted,
  accountSeries,
} from './accountHistory'
import type { AccountSection } from './detailScope'
import { StatementsTable } from './StatementsTable'

const MIN_CHART_POINTS = 2

interface AccountCardProps {
  section: AccountSection
  overview: PortfolioOverview
  asOfDate: string
}

// The chosen account: its value, how it moved, its money in and out and one row per statement.
// It has no title or badge: the Showing line above names the account and carries its verdict.
export const AccountCard = ({
  section,
  overview,
  asOfDate,
}: AccountCardProps) => {
  const { account, timeline } = section
  const series = accountSeries(timeline, account.month)
  const { window, totals } = account.money
  const { ledgerIncomplete } = useLedgerGap()
  return (
    <section className="@container rounded-lg border bg-white p-6 text-sm text-blue-7">
      <div className="grid grid-cols-1 gap-x-16 gap-y-8 @4xl:grid-cols-[minmax(0,1fr)_420px]">
        <div className="min-w-0">
          <AccountFigure account={account} asOfDate={asOfDate} />
          {series.length >= MIN_CHART_POINTS && (
            <TotalOverTimeChart
              series={series}
              asOfMonth={account.month}
              label="Securities and cash at each month end"
            />
          )}
        </div>
        {window && totals && (
          <MoneyInOut
            window={window}
            totals={totals}
            notCounted={accountNotCounted(timeline, account.month, window)}
            accountCount={1}
            isLedgerIncomplete={ledgerIncomplete != null}
          />
        )}
      </div>
      <StatementsTable
        rows={accountHistory(overview, timeline, account.month)}
      />
    </section>
  )
}
